import API_BASE from './apiBase';

const apiOrigin = API_BASE.replace(/\/api$/, '');

export function tenantIconUrl(slug, size = 192, maskable = false) {
  if (!slug) return '';
  const suffix = maskable ? `${size}-maskable.png` : `${size}.png`;
  return `${apiOrigin}/api/public/workforce/${encodeURIComponent(slug)}/icons/${suffix}`;
}

export function workforceAppShortName(tenantName) {
  const cleaned = String(tenantName || 'Portal').replace(/\s+/g, ' ').trim();
  if (!cleaned) return 'Portal';
  if (/\bportal$/i.test(cleaned)) return cleaned.length <= 24 ? cleaned : `${cleaned.split(' ')[0].slice(0, 12)} Portal`;
  if (cleaned.length <= 16) return `${cleaned} Portal`;
  return `${cleaned.split(' ')[0].slice(0, 12)} Portal`;
}

export function workforceAppFullName(tenantName) {
  const cleaned = String(tenantName || 'Your care provider').replace(/\s+/g, ' ').trim();
  return `${cleaned || 'Your care provider'} Applicant & Workforce Portal`;
}

function upsertElement(selector, createTag, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement(createTag);
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([name, value]) => {
    if (value === null || value === undefined) {
      element.removeAttribute(name);
    } else {
      element.setAttribute(name, value);
    }
  });
  return element;
}

export function updateWorkforceAppMetadata({ tenantName, shortName, slug, primaryColour }) {
  if (!tenantName || !slug) return;
  const title = workforceAppFullName(tenantName);
  const manifestHref = `${apiOrigin}/api/public/workforce/${encodeURIComponent(slug)}/manifest.webmanifest`;
  const iconHref = tenantIconUrl(slug, 192);
  const resolvedShortName = shortName || workforceAppShortName(tenantName);

  document.title = title;
  upsertElement('link[rel="manifest"][data-workforce-app="true"]', 'link', {
    rel: 'manifest',
    href: manifestHref,
    crossorigin: 'anonymous',
    'data-workforce-app': 'true',
  });
  upsertElement('meta[name="theme-color"]', 'meta', {
    name: 'theme-color',
    content: /^#[0-9a-fA-F]{6}$/.test(primaryColour || '') ? primaryColour : '#0F766E',
  });
  upsertElement('meta[name="application-name"]', 'meta', {
    name: 'application-name',
    content: resolvedShortName,
  });
  upsertElement('meta[name="apple-mobile-web-app-title"]', 'meta', {
    name: 'apple-mobile-web-app-title',
    content: resolvedShortName,
  });
  upsertElement('link[rel="apple-touch-icon"][data-workforce-app="true"]', 'link', {
    rel: 'apple-touch-icon',
    href: iconHref,
    'data-workforce-app': 'true',
  });
}

export function registerWorkforceServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  if (!window.location.pathname.startsWith('/workforce') && !window.location.pathname.startsWith('/worker')) return;
  navigator.serviceWorker.register('/workforce-service-worker.js', { scope: '/' }).catch(() => {
    // Installation support must never block normal browser access.
  });
}
